/**
 * The ink a campaign figure is drawn in. The detail page colours numbers by
 * what they mean — attention, money, harm — rather than by where they sit, so
 * the vocabulary lives here and every card reaches for the same names.
 */
export const CAMPAIGN_TONES = {
  default: 'text-gray-900',
  ink: 'text-announce-ink',
  /** Something is waiting on a human. */
  attention: 'text-campaign-attention',
  /** Opted out / unsubscribed. */
  paused: 'text-campaign-paused',
  /** Delivered, booked — the good outcome. */
  done: 'text-campaign-done',
  /** Failed, bounced, undeliverable. */
  stopped: 'text-campaign-stopped',
  /** Replied, clicked — engagement. */
  accent: 'text-campaign-running',
  muted: 'text-gray-500',
  faint: 'text-gray-300',
} as const

export type CampaignTone = keyof typeof CAMPAIGN_TONES
